import { render, staticRenderFns } from "./wx-open-app.vue?vue&type=template&id=a50146d4&scoped=true&"
import script from "./wx-open-app.vue?vue&type=script&lang=js&"
export * from "./wx-open-app.vue?vue&type=script&lang=js&"
import style0 from "./wx-open-app.vue?vue&type=style&index=0&id=a50146d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50146d4",
  null
  
)

export default component.exports